import React from 'react';

const CardBccard = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
    >
      <path
        d="M2 0.5H22C22.8284 0.5 23.5 1.17157 23.5 2V14C23.5 14.8284 22.8284 15.5 22 15.5H2C1.17157 15.5 0.5 14.8284 0.5 14V2C0.5 1.17157 1.17157 0.5 2 0.5Z"
        fill="white"
        stroke="#E2E6F3"
      />
    </svg>
  );
};

export default CardBccard;
